import React, { useMemo, useState } from 'react';
import { Row, Col, Grid, Button } from 'antd'
import { COLOR, FONT } from '../constants';
import MintButton from '../components/MintButton'
import TNContent from './TNContent';


const CollectionMint = (props) => {
  const [clicked, setClicked] = useState(false);

  // console.log('onMint', onMint)
  const screens = Grid.useBreakpoint();

  const isMobile = useMemo(() => {
    return !screens.md;
  }, [screens.md])

  return (
    <TNContent maxWidth={1920}>
      <Row
        justify='center'
        align='center'
        style={{ backgroundColor: COLOR.background, padding: '5% 0px', textAlign: 'center' }}>
        <Col span={24}>
          <img src="./assets/primary_star.svg" alt="" style={{ width: 40, }} />
          <p style={{ ...FONT.h6, color: COLOR.primary }}>THE COLLECTION</p>
          <p style={{ ...FONT.h3, color: COLOR.heading }}> Shiba9 </p>
          {isMobile ? (
            <div style={{
              backgroundColor: COLOR.primary,
              border: '4px solid #000000',
              boxShadow: '6px 7px 0px #000000',
              borderRadius: 8,
              margin: '30px 30px',
              padding: '20px 30px'
            }}>
              <Row gutter={[12, 0]} style={{ marginBottom: 30 }}>
                <Col>
                  <div style={{ borderRadius: '100%', width: 14, height: 14, background: COLOR.nagative, border: '3px solid #1A1A1A', display: 'inline-block' }}></div>
                </Col>
                <Col>
                  <div style={{ borderRadius: '100%', width: 14, height: 14, background: COLOR.warning, border: '3px solid #1A1A1A', display: 'inline-block' }}></div>
                </Col>
                <Col>
                  <div style={{ borderRadius: '100%', width: 14, height: 14, background: COLOR.success, border: '3px solid #1A1A1A', display: 'inline-block' }}></div>
                </Col>
              </Row>
              <p style={{ ...FONT.smallCaptionText, color: COLOR.heading }}>
                Minting an NFT is not difficult, especially when we can provide you a convenient way to mint it yourself at the least cost!
              </p>
              <br />
              <p style={{ ...FONT.smallCaptionText, color: COLOR.heading }}>
                To celebrate technine’s 3rd birthday and the launch of our new blockchain brand - <b>NineBlocks</b>, we’ve launched our first NFT collection - <b>Shiba9</b> with a tool for everyone to experience the minting process with confidence.
              </p>
            </div>
          ) :
            <Row justify='center'>
              <Col span={16}>
                {/* Top Left Box*/}
                <div style={{ width: 140, height: 140, border: '4px solid #000000', position: 'absolute', top: -30, left: -30, zIndex: 0 }}>
                  <div style={{ position: 'absolute', top: -8, left: -8, width: 12, height: 12, background: COLOR.primary }}></div>
                  <div style={{ position: 'absolute', top: -8, right: -8, width: 12, height: 12, background: COLOR.primary }}></div>
                  <div style={{ position: 'absolute', bottom: -8, left: -8, width: 12, height: 12, background: COLOR.primary }}></div>
                </div>
                {/* Bottom Right Box*/}
                <div style={{ width: 140, height: 140, border: '4px solid #000000', position: 'absolute', bottom: 0, right: -30, zIndex: 0 }}>
                  <div style={{ position: 'absolute', top: -8, right: -8, width: 12, height: 12, background: COLOR.primary }}></div>
                  <div style={{ position: 'absolute', bottom: -8, left: -8, width: 12, height: 12, background: COLOR.primary }}></div>
                  <div style={{ position: 'absolute', bottom: -8, right: -8, width: 12, height: 12, background: COLOR.primary }}></div>
                </div>
                {/* Content Box */}
                <div style={{
                  backgroundColor: COLOR.primary,
                  border: '4px solid #000000',
                  boxShadow: '6px 7px 0px #000000',
                  borderRadius: 8,
                  margin: '30px 30px',
                  padding: '20px 30px',
                  zIndex: 2,
                  position: 'relative'
                }}>
                  <Row gutter={[12, 0]} style={{ marginBottom: 30 }}>
                    <Col>
                      <div style={{ borderRadius: '100%', width: 14, height: 14, background: COLOR.nagative, border: '3px solid #1A1A1A', display: 'inline-block' }}></div>
                    </Col>
                    <Col>
                      <div style={{ borderRadius: '100%', width: 14, height: 14, background: COLOR.warning, border: '3px solid #1A1A1A', display: 'inline-block' }}></div>
                    </Col>
                    <Col>
                      <div style={{ borderRadius: '100%', width: 14, height: 14, background: COLOR.success, border: '3px solid #1A1A1A', display: 'inline-block' }}></div>
                    </Col>
                  </Row>
                  <p style={{ ...FONT.captionText, color: COLOR.heading }}>
                    Minting an NFT is not difficult, especially when we can provide you a convenient way to mint it yourself at the least cost!
                  </p>
                  <br />
                  <p style={{ ...FONT.captionText, color: COLOR.heading }}>
                    To celebrate technine’s 3rd birthday and the launch of our new blockchain brand - <b>NineBlocks</b>, we’ve launched our first NFT collection - <b>Shiba9</b> with a tool for everyone to experience the minting process with confidence.
                  </p>
                </div>
              </Col>
            </Row>
          }
        </Col>
        <Col span={24} style={{ margin: '20px 0' }}>
          <MintButton onClick={() => { props.setModalVisible(true) }} />
          {/* <MintButton
        setAlertState={props.setAlertState}
        setModalVisible={props.setModalVisible}
        setClicked={setClicked}
        clicked={clicked}
        candyMachine={props?.candyMachine}
        isMinting={props.isMinting}
        // setIsMinting={props.setIsMinting}
        isActive={props.isActive}
        isEnded={props.isEnded}
        isSoldOut={props.isSoldOut}
        onMint={props.startMint}
        success={props?.alertState?.severity === 'success' ?? false}
        setIsMinting={props?.setIsMinting}/> */}
        </Col>
      </Row>
    </TNContent>
  )
}

export default CollectionMint;